import { Instagram, Heart, MapPin, Phone } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 border-t border-border relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 opacity-30">
        <div 
          className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full"
          style={{
            background: 'radial-gradient(ellipse, rgba(255, 215, 0, 0.15) 0%, transparent 70%)',
            filter: 'blur(60px)',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col items-center text-center">
          {/* Logo */}
          <div className="mb-6">
            <img 
              src="/images/logo.png" 
              alt="KPC Urban Korean Food" 
              className="h-16 w-auto mx-auto object-contain"
            />
          </div>

          {/* Tagline */}
          <p className="text-muted-foreground max-w-md mb-6">
            Authentic Korean urban food with a modern urban twist. 
            Made with love in Kissimmee, Florida.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4 mb-6">
            <a
              href="https://instagram.com/kpc.urbankoreanfood"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-[#FFD700]/10 flex items-center justify-center hover:bg-[#FFD700]/20 transition-colors"
            >
              <Instagram className="w-5 h-5 text-[#FFD700]" />
            </a>
          </div>

          {/* Contact Info */}
          <div className="glass-card rounded-xl p-4 mb-8 max-w-sm">
            <div className="flex items-start gap-3 mb-3">
              <MapPin className="w-5 h-5 text-[#FFD700] mt-0.5 flex-shrink-0" />
              <div className="text-left">
                <p className="text-white text-sm">6083 W Irlo Bronson Memorial Hwy</p>
                <p className="text-muted-foreground text-sm">Kissimmee, FL 34747</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Phone className="w-5 h-5 text-[#FFD700] flex-shrink-0" />
              <a href="tel:4075070287" className="text-white text-sm hover:text-[#FFD700] transition-colors">
                (407) 507-0287
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex flex-wrap justify-center gap-6 mb-8">
            <a href="#home" className="text-sm text-muted-foreground hover:text-[#FFD700] transition-colors">
              Home
            </a>
            <a href="#story" className="text-sm text-muted-foreground hover:text-[#FFD700] transition-colors">
              Our Story
            </a>
            <a href="#menu" className="text-sm text-muted-foreground hover:text-[#FFD700] transition-colors">
              Menu
            </a>
            <a href="#about" className="text-sm text-muted-foreground hover:text-[#FFD700] transition-colors">
              About
            </a>
            <a href="#contact" className="text-sm text-muted-foreground hover:text-[#FFD700] transition-colors">
              Contact
            </a>
          </div>

          {/* Divider */}
          <div className="w-full max-w-xs h-px bg-gradient-to-r from-transparent via-[#FFD700]/30 to-transparent mb-6" />

          {/* Copyright */}
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <span>Made with</span>
            <Heart className="w-4 h-4 text-[#DC143C] fill-[#DC143C]" />
            <span>by KPC Team</span>
          </div>
          <p className="text-xs text-muted-foreground mt-2">
            {currentYear} KPC Urban Korean Food. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
